import { beginArticleLinksNavigation } from '@/redux/modules/articleLinks/articleLinks.actions';
import { fetchArticleLinksIfCurrent } from '@/redux/modules/articleLinks/articleLinks.loader';
import { getItemFacets } from '@/redux/modules/itemFacets';
import { fetchDataForItemPage } from '@/redux/modules/itemPage/itemPage.actions';
import { DataLoaderParams } from '@/types/DataLoaderParams';
import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { UNIFIED_CLIP_VECTOR_VERSION } from '@/utils/amplitude/experiments/hooks/useSimilarLotsUnifiedClip.experiment';
import { getIdFromPath, getNotFoundUrl } from '@/utils/urls';

import { getItemArticleLinksParams } from './getItemArticleLinksParams';

export const itemPageData = async ({
    amplitudeExperimentFlags,
    location,
    match: { params },
    redirect,
    referrer,
    store: { dispatch, getState },
}: DataLoaderParams) => {
    const itemId = getIdFromPath(params.itemId);

    if (!itemId) {
        return redirect(getNotFoundUrl());
    }

    const articleLinksNavigationId = dispatch(beginArticleLinksNavigation());

    // Always use new similar items for bots
    const useNewSimilarItems = true;
    // Scout categories should always be true for SSR
    const useScoutCategories = true;

    const hasUnifiedClipTreatment =
        amplitudeExperimentFlags[AmplitudeExperiments.SimilarLotsUnifiedClip]?.value ===
        AmplitudeVariants.SimilarLotsUnifiedClip.Treatment;
    const vectorVersion = hasUnifiedClipTreatment ? UNIFIED_CLIP_VECTOR_VERSION : undefined;

    await dispatch(
        fetchDataForItemPage({
            itemId,
            location,
            redirect,
            referrer,
            shouldUseSignalsBoost: true,
            useNewSimilarItems,
            useScoutCategories,
            vectorVersion,
        })
    );

    const facets = getItemFacets(getState(), itemId);
    await fetchArticleLinksIfCurrent({
        amplitudeExperimentFlags,
        dispatch,
        getState,
        navigationId: articleLinksNavigationId,
        params: getItemArticleLinksParams(facets),
    });
};
